<div class="input-wrapper">
  <div
    class="input-field"
    [class.has-error]="hasError"
    [class.disabled]="disabled"
  >
    <!-- Label -->
    <span class="field-label" *ngIf="label"
      >{{ label }} <span *ngIf="required" class="field-hint error"> *</span>
    </span>

    <div class="field-row">
      <!-- ── Auto icon based on inputType ── -->
      <span class="field-icon">
        <!-- text icon: person -->
        <svg
          *ngIf="inputType === 'text'"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
        >
          <circle cx="12" cy="8" r="4" />
          <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
        </svg>

        <!-- email icon: envelope -->
        <svg
          *ngIf="inputType === 'email'"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
        >
          <rect x="2" y="4" width="20" height="16" rx="2" />
          <polyline points="2,4 12,13 22,4" />
        </svg>

        <!-- phone icon: handset -->
        <svg
          *ngIf="inputType === 'phone'"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
        >
          <path
            d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.39 19a19.45 19.45 0 0 1-6-6A19.79 19.79 0 0 1 3.09 4.18 2 2 0 0 1 5.06 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.69 2.81a2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.33 1.85.56 2.81.69A2 2 0 0 1 22 16.92z"
          />
        </svg>
      </span>

      <!-- ── Native input ── -->
      <input
        class="field-input"
        [type]="nativeType"
        [placeholder]="defaultPlaceholder"
        [disabled]="disabled"
        [value]="value"
        (input)="onInput($event)"
        (blur)="onBlur()"
      />

      <!-- ── Clear × ── -->
      <button
        type="button"
        class="field-clear"
        [class.visible]="value && clearable && !disabled"
        (click)="clearValue($event)"
        tabindex="-1"
        title="Clear"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Hint / error -->
  <p class="field-hint" *ngIf="hint && !hasError">{{ hint }}</p>
  <p class="field-hint error" *ngIf="hasError">{{ computedError }}</p>
  <p class="field-hint" *ngIf="!(hint && !hasError) || !hasError"></p>
</div>
